// extracted by mini-css-extract-plugin
export default {"dot":"ChatShowcase_dot__fvaV2","dotAnimated":"ChatShowcase_dotAnimated__f94CP","dot-bounce":"ChatShowcase_dot-bounce__JhONz","dot-color":"ChatShowcase_dot-color__pnn9r"};